import MedalStandingsScreen from './MedalStandingsScreen';

export default MedalStandingsScreen;